import requests from "./httpServices";

const NoticeServices = {
  getAllNotice() {
    return requests.get("/notice/");
  },
  getNoticeWithPagination(page, limit) {
    return requests.get(`/notice?page=${page}&limit=${limit}`);
  },
  getNoticeById(id) {
    return requests.get(`/notice/${id}`);
  },
  getShowingNotice() {
    return requests.get(`/notice?show=true`);
  },

  addNotice(body) {
    return requests.post("/notice", body);
  },

  updateNotice(id, body) {
    return requests.put(`/notice/${id}`, body);
  },

  updatePublishANotice(id) {
    return requests.put(`/notice/${id}?show=true`);
  },

  deleteNotice(id) {
    return requests.delete(`/notice/${id}`);
  },
};

export default NoticeServices;
